<template>
  <div>
    <TeamForm @clearOriginalEditingTeam="editingTeam = null" :originalEditingTeam="editingTeam"></TeamForm>
    <TeamsOverview @editTeam="editingTeam = $event"></TeamsOverview>
  </div>
</template>

<script>
import TeamForm from "@/components/teams/TeamsForm";
import TeamsOverview from "@/components/teams/TeamsOverview";
export default {
  name: "Teams",
  components: {TeamsOverview, TeamForm},
  data() {
    return {
      editingTeam: null
    }
  },
  computed: {

  }
}
</script>

<style scoped>

</style>